module.exports = __webpack_public_path__ + "img/rate4.aa1484fa.svg";